(function () {
	'use strict';
	
    angular.module("imApp").factory("deliveryMethodService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 386,
                    parameters: parms || {}
                });
            },
            listReturnMethods: function (parms) {
                return $ihttp.post({
                    method: 1598,
                    parameters: parms || {}
                });
            },
            listTransCarriers: function (parms) {
                return $ihttp.post({
                    method: 388,
                    parameters: parms || {}
                });
            },
            listTransCarrierProducts: function (parms) {
                return $ihttp.post({
                    method: 389,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 391,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 392,
                    parameters: edit
                });
            }
		};

        return service;
    }]);
})();
